import { z, isoZ } from 'my-zod'
import { operatorGroupFeatureFlagOptions } from './operator-group-feature-flags'

export const OutfitterFeaturePackageOptions = ['Arrival', 'MPWRBook', 'DealerDemoRide'] as const
export type OutfitterFeaturePackage = (typeof OutfitterFeaturePackageOptions)[number]

export const operatorGroupsModel = z.object({
  id: z.number(),
  shortId: z.string(),
  name: z.string().nullable(),
  featurePackage: z.enum(OutfitterFeaturePackageOptions),
  featureFlags: z.enum(operatorGroupFeatureFlagOptions).array(),
  lastModifiedDate: isoZ.instant().nullable(),
  deletedDate: isoZ.instant().nullable()
})

export type operatorGroupsModel = z.infer<typeof operatorGroupsModel>
